export default __webpack_public_path__ + "static/media/thumbnail_blog_7.4b0c7b5c.png";